<template>
  <div class="jianli_box">
    <div class="resume_box">
      <div class="left">
        <div class="menu_item" :class="currentMenu==item.id?'active_menu_item':''" v-for=" item in menuData" :key="item.id">
          <a @click.prevent="anchor(item )">{{ item.name }}</a>
        </div>

      </div>
      <div class="right_box">
        <el-scrollbar style="height: 100%;width: 100%;">
          <div class="Personal_information" v-if="!menuData[1].isedit" id="简历目录">
            <div class="image_box">
              <UploadFileWidget ref="uploadFileRef" :accept="fileTypes.join(',')" :limit-size="1024 * 1024 * 200" :beforeUpload="handleBeforeUpload" @progress="isUpload = false" @success="handleUploadSuccess" @error="isUpload = false">
                <div class="file-top_btn" slot="target">
                  <img v-if="!personalInfo.avatar" src="@/assets/img/company/detial/jianli/img1.png" alt="">
                  <img v-else :src="personalInfo.avatar" alt="">
                  <div class="reset_button">
                    <i class="el-icon-refresh-right"></i>
                    {{!personalInfo.avatar?'点击上传':'重新上传'}}
                  </div>
                </div>
              </UploadFileWidget>

            </div>
            <div class="personal_info">
              <div class="name">
                <span class="person_name">{{ personalInfo.name }}</span>
                <div class="right_button_box">
                  <span style="display: flex;align-items: center; cursor: pointer;" @click="editInfo(1)">
                    <img v-if="menuData[1].isValue" src="@/assets/img/company/detial/jianli/icon10.png" alt="">
                    <img v-else src="@/assets/img/company/detial/jianli/icon11.png" alt="">
                    <span style="margin-right: 20px;">{{personalInfo.telephone?'编辑':'添加'}}</span>
                  </span>
                  <img src="@/assets/img/company/detial/jianli/icon8.png" alt="">
                  <span @click="viewResume" style="cursor: pointer;">预览简历</span>
                </div>
              </div>
              <div class="detial_jianli">
                <div class="detial_item" v-for="item in workExperience" :key="item.key">
                  <img :src="item.icon" alt="">
                  <span class="content">{{ !personalInfo[item.key]?item.label:personalInfo[item.key] }}</span>
                </div>

              </div>

            </div>
          </div>
          <div class="edit_box" v-else>
            <EditorResume :editObj="menuData[1]" :info="personalInfo" @cancleEdit="cancleEdit" @finishEdit="finishEdit" />
          </div>
          <div class="all_info">
            <div v-for="(item,index) in menuData" :key="item.id" :id="item.name">
              <div class="item_box" v-if="index>1">
                <div class="header_box" v-if="!menuData[index].isedit">
                  <div class="left">
                    <img :src="item.icon" alt="" /></img>
                    <span class="name">{{ item.name }}</span>
                  </div>
                  <div class="left" style="cursor: pointer;" @click="editInfo(index)">
                    <img v-if="menuData[index].isValue && ![ 3,4, 5,6,7].includes(index)" src="@/assets/img/company/detial/jianli/icon10.png" alt="">
                    <img v-else src="@/assets/img/company/detial/jianli/icon11.png" alt="">
                    <span class="label" style="margin-right: 20px;" v-if="[ 3,4, 5,6,7].includes(index)">添加</span>
                    <span class="label" style="margin-right: 20px;" v-else>{{personalInfo.personal_advantages?'编辑':'添加'}}</span>
                  </div>
                </div>
                <div v-if="index==2 && !menuData[index].isedit" class="info_content">
                  <span v-if="personalInfo.personal_advantages" v-html="personalInfo.personal_advantages.replace(/\n/g, '<br>')"></span>
                  <span v-else>暂无个人优势 </span>

                </div>
                <div v-if="index==3 && !menuData[index].isedit" class="info_content">
                  <Expectedposition v-if="index==3" :data="personalInfo.position" :edit="false" @edit="handleEditPosition" @delete="handleDeletePositione" />
                </div>

                <div v-if="index == 4 && !menuData[index].isedit" class="info_content">
                  <WorkExperience :data="personalInfo.work_experience" :edit="false" @edit="handleEditWorkExperience" @delete="handleDeleteWorkExperience"></WorkExperience>
                </div>
                <div v-if="index == 6 && !menuData[index].isedit" class="info_content">
                  <Educationalbackground :data="personalInfo.education_experience" :edit="false" @edit="handleEditEductionExperience" @delete="handleDeleteEducationExperience"></Educationalbackground>
                </div>

                <div v-if="index == 5 && !menuData[index].isedit" class="info_content">
                  <ProjectExperience :data="personalInfo.project_experience" :edit="false" @edit="handleEditProjectExperience" @delete="handleDeleteProjectExperience"></ProjectExperience>
                </div>

                <div v-if="index == 7 && !menuData[index].isedit" class="info_content">
                  <CertificateList :data="personalInfo.certificate_list" @delete="handleDeleteCertificate"></CertificateList>
                </div>

                <div v-if="[2, 3,4, 5,6].includes(index) && menuData[index].isedit" class="info_edit">
                  <EditorResume :editObj="item" :info="personalInfo" :workExperienceIndex="workExperienceIndex" :positionIndex="positionIndex" :projectExperienceIndex="projectExperienceIndex" :educationIndex="educationIndex"
                    @cancleEdit="cancleEdit" @finishEdit="finishEdit" />
                </div>
              </div>
            </div>

          </div>
        </el-scrollbar>

      </div>
    </div>
    <viewResumeDialogStudent ref="viewPositionRef" :position_info="personalInfo" :value="drawerVisible" @closeDrawer="closeDrawer" />
    <CheckCertificateDialog v-model="certificateVisible" :certificateList="personalInfo.certificate_list" @change="handleChangeCertificate"></CheckCertificateDialog>
  </div>
</template>

<script>
import EditorResume from "../../../../components/recruitmentCenter/EditorResume.vue";
import WorkExperience from "../../../../components/recruitmentCenter/components/WorkExperience.vue";
import ProjectExperience from "../../../../components/recruitmentCenter/components/ProjectExperience.vue";
import CheckCertificateDialog from "../../../../components/recruitmentCenter/components/CheckCertificateDialog.vue";
import CertificateList from "../../../../components/recruitmentCenter/components/CertificateList.vue";
import Educationalbackground from "../../../../components/recruitmentCenter/components/Educationalbackground.vue";
import Expectedposition from "../../../../components/recruitmentCenter/components/Expectedposition.vue";
import UploadFileWidget from "@/utils/upload/UploadFileWidget.vue";
import viewResumeDialogStudent from "../../../../components/companyModule/viewResumeDialogStudent.vue";
import getCity from "../../../../components/recruitmentCenter/js/data";
export default {
  name: "",
  components: {
    EditorResume,
    WorkExperience,
    ProjectExperience,
    CheckCertificateDialog,
    CertificateList,
    Educationalbackground,
    UploadFileWidget,
    Expectedposition,
    viewResumeDialogStudent,
  },
  data() {
    return {
      position_info: {},
      drawerVisible: false,
      fileTypes: [".jpg", ".jpeg", ".png"],
      currentMenu: 1,
      workExperienceIndex: null,
      projectExperienceIndex: null, // 项目经历Info
      certificateVisible: false,
      educationIndex: null, //教育经历
      positionIndex: null,
      menuData: [
        {
          name: "简历目录",
          id: 1,
          isedit: false,
          isValue: false,
        },
        {
          name: "个人信息",
          icon: require("@/assets/img/company/detial/jianli/icon1.png"),
          id: 2,
          isedit: false,
          isValue: false,
          func: (val) => this.savePersonalInformation(val),
        },
        {
          name: "个人优势",
          icon: require("@/assets/img/company/detial/jianli/icon2.png"),
          id: 3,
          isedit: false,
          isValue: false,
          func: (val) => this.savePersonalStrengths(val),
        },
        {
          name: "期望职位",
          id: 4,
          icon: require("@/assets/img/company/detial/jianli/icon3.png"),
          isedit: false,
          isValue: false,
          func: (val) => this.savePosition(val),
        },
        {
          name: "工作经历",
          icon: require("@/assets/img/company/detial/jianli/icon4.png"),
          id: 5,
          isedit: false,
          isValue: false,
          func: (val) => this.saveWorkExperience(val),
        },
        {
          name: "项目经历",
          icon: require("@/assets/img/company/detial/jianli/icon5.png"),
          id: 6,
          isedit: false,
          isValue: false,
          func: (val) => this.saveProjectExperience(val),
        },
        {
          name: "教育经历",
          icon: require("@/assets/img/company/detial/jianli/icon6.png"),
          id: 7,
          isedit: false,
          isValue: false,
          func: (val) => this.saveEducation(val),
        },
        {
          name: "资格证书",
          icon: require("@/assets/img/company/detial/jianli/icon7.png"),
          id: 8,
          isedit: false,
          isValue: false,
          func: (val) => this.saveCertificate(val),
        },
      ],
      jobStatusOption: [
        {
          label: "离职-随时到岗",
          value: 1,
        },
        {
          label: "在职-暂不考虑",
          value: 2,
        },
        {
          label: "在职-考虑机会",
          value: 3,
        },
        {
          label: "在职-月内到岗",
          value: 4,
        },
      ],
      workExperience: [
        {
          key: "experience",
          label: "暂无工作经验",
          icon: require("@/assets/img/company/detial/jianli/icon2-1.png"),
        },
        {
          key: "degree",
          label: "暂无学历",
          icon: require("@/assets/img/company/detial/jianli/icon1-1.png"),
        },
        {
          key: "status",
          label: "暂无当前求职状态",

          icon: require("@/assets/img/company/detial/jianli/icon3-1.png"),
        },
        {
          key: "telephone",
          label: "暂无电话",
          icon: require("@/assets/img/company/detial/jianli/icon4-1.png"),
        },
        {
          key: "wechat",
          label: "暂无微信",
          icon: require("@/assets/img/company/detial/jianli/icon5-1.png"),
        },
        {
          key: "email",
          label: "暂无邮箱",
          icon: require("@/assets/img/company/detial/jianli/icon6-1.png"),
        },
      ],
      editValue: {
        title: "",
        id: 2,
      },
      personalInfo: {
        id: "",
        name: "",
        avatar: "",
        status: null,
        gender: "",
        age: "",
        telephone: "",
        wechat: "",
        experience: "",
        email: "",
        workStart: "",
        educational_background: "",
        personal_advantages: "",
        type_job: 1,
        hope_position: "", //期望职位
        hope_position_value: [], //
        hop_industry: "", //期望行业
        hop_industry_value: [],
        salary_range: "",
        salary_min: null,
        salary_max: null,
        city_work: "",
        city_work_value: [],
        hope_city: "",
        hope_city_value: [],
        position: [], //期待职业
        work_experience: [], // 工作经历
        project_experience: [], // 项目经历
        certificate_list: [], // 资格证书列表
        education_experience: [],
      },
    };
  },
  mounted() {
    this.getInfoDetial();
    // getCity();
  },
  methods: {
    getInfoDetial() {
      this.$httpStudent.axiosGet(this.$api.resumeDetail, (res) => {
        if (res.code === 200) {
          if (res.data.length == 0) return;
          let keys = [
            { key1: "id", key2: "id" },
            { key1: "name", key2: "name" },
            { key1: "avatar", key2: "avatar" },
            { key1: "gender", key2: "gender" },
            { key1: "degree", key2: "degree" },
            { key1: "experience", key2: "experience" },
            { key1: "statusValue", key2: "job_status" },
            { key1: "telephone", key2: "phone" },
            { key1: "workStart", key2: "join_time" },
            { key1: "age", key2: "birth_time" },
            { key1: "email", key2: "email" },
            { key1: "wechat", key2: "wechat" },
            { key1: "personal_advantages", key2: "personal_strengths" },
            { key1: "position", key2: "position" },
            { key1: "work_experience", key2: "work_experience" },
            { key1: "project_experience", key2: "project_experience" },
            { key1: "education_experience", key2: "education" },
            { key1: "certificate_list", key2: "certificate" },
          ];
          for (let i = 0; i < keys.length; i++) {
            if (keys[i].key1 && keys[i].key2) {
              this.personalInfo[keys[i].key1] =
                res.data[keys[i].key2] === 0 ? null : res.data[keys[i].key2];
            }
          }
          this.personalInfo.status = this.personalInfo.statusValue
            ? this.jobStatusOption[this.personalInfo.statusValue - 1].label
            : null;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    editInfo(index) {
      if (index === 7) {
        this.certificateVisible = true;
      } else {
        this.workExperienceIndex = null;
        this.projectExperienceIndex = null;
        this.educationIndex = null;
        this.positionIndex = null;

        this.$set(this.menuData[index], "isedit", true);
      }
      if (index == 1) {
        if (this.personalInfo.telephone) {
          this.$set(this.menuData[index], "isValue", true);
        } else {
          this.$set(this.menuData[index], "isValue", false);
        }
      } else if (index == 2) {
        if (this.personalInfo.personal_advantages) {
          this.$set(this.menuData[index], "isValue", true);
        } else {
          this.$set(this.menuData[index], "isValue", false);
        }
      } else {
        this.$set(this.menuData[index], "isValue", false);
      }
    },
    cancleEdit(index) {
      this.menuData[index].isedit = !this.menuData[index].isedit;
    },
    finishEdit(val, index) {
      this.menuData[index].isValue = true;
      this.menuData[index].isedit = !this.menuData[index].isedit;
      this.menuData[index]?.func?.(val);
    },
    // 编辑期望职位
    handleEditPosition(index) {
      this.positionIndex = index;
      this.$set(this.menuData[3], "isedit", true);
      this.$set(this.menuData[3], "isValue", true);
    },
    // 工作经历
    handleEditWorkExperience(index) {
      this.workExperienceIndex = index;
      this.$set(this.menuData[4], "isedit", true);
      this.$set(this.menuData[4], "isValue", true);
    },
    // 项目经历
    handleEditProjectExperience(index) {
      this.projectExperienceIndex = index;
      this.$set(this.menuData[5], "isedit", true);
      this.$set(this.menuData[5], "isValue", true);
    },
    // 教育背景
    handleEditEductionExperience(index) {
      this.educationIndex = index;
      this.$set(this.menuData[6], "isedit", true);
      this.$set(this.menuData[6], "isValue", true);
    },
    // 删除  期望职位
    handleDeletePositione(id) {
      let params = {
        position_id: id,
      };
      this.deleteInfo("resumeDeletePosition", params);
    },
    // 工作经历
    handleDeleteWorkExperience(id) {
      let params = {
        work_id: id,
      };
      this.deleteInfo("resumeDeleteWorkExperience", params);
    },
    // 项目经历
    handleDeleteProjectExperience(id) {
      let params = {
        project_id: id,
      };
      this.deleteInfo("resumeDeleteProjectExperience", params);
    },
    // 教育背景
    handleDeleteEducationExperience(id) {
      let params = {
        education_id: id,
      };
      this.deleteInfo("resumeDeleteEducation", params);
    },

    anchor(item) {
      let anchorElement = document.getElementById(item.name);
      this.currentMenu = item.id;
      /*如果对应id的锚点存在，就跳转到锚点*/
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    },

    // 增加资格证书
    handleChangeCertificate(val) {
      this.saveCertificate(val);
    },

    // 删除资格证书
    handleDeleteCertificate(index) {
      this.personalInfo.certificate_list.splice(index, 1);
      this.saveCertificate(this.personalInfo.certificate_list)
    },
    // 上传前
    handleBeforeUpload(file) {
      return true;
    },

    // 上传进度条
    handleUploadSuccess(val) {
      this.personalInfo.avatar = val.path;
      this.saveAvator();
    },
    saveAvator() {
      let params = {
        avatar: this.personalInfo.avatar,
      };
      this.$httpStudent.axiosPost(this.$api.resumeSaveAvatar, params, (res) => {
        if (res.code === 200) {
          this.$message.success("头像修改成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    savePersonalInformation(val) {
      let params = {
        name: val.name, //姓名
        gender: val.gender, //性别: 1=男,2=女
        job_status: val.statusValue, //求职状态: 1=离职-随身到岗,2=在职-暂不考虑,3=在职-考虑机会,4=在职-月内到岗
        phone: val.telephone, //电话
        birth_time: val.age, //出生年月
        join_time: val.workStart, //参加工作时间
        email: val.email, //邮箱
        wechat: val.wechat, //微信
      };
      this.SaveInfo("resumeSavePersonalInformation", params);
    },
    savePersonalStrengths(val) {
      let params = { personal_strengths: val.personal_advantages };
      this.SaveInfo("resumeSavePersonalStrengths", params);
    },
    savePosition(val) {
      let params = {
        position_id: val.position_id, //职位id，编辑时必填
        name: val.name, //职位名称
        position_type: val.position_type, //职位类型, 1=全职，2=兼职
        industry: val.industry, //行业
        salary_min: val.salary_min * 1000, //薪资范围-最低
        salary_max: val.salary_max * 1000, //薪资范围-最高
        city: val.city, //工作城市
        other_city: val.other_city, //其他感兴趣城市
      };
      this.SaveInfo("resumeSavePosition", params);
    },
    saveWorkExperience(val) {
      let params = {
        work_id: val.work_id, //工作经历id，编辑时必填
        company_name: val.company, //公司名称
        industry: val.industry[val.industry.length - 1], //行业
        position_name: val.post[val.post.length - 1], //职位名称
        start_time: val.time[0], //项目-开始日期
        end_time: val.time[1], //项目-结束日期
        work_responsibilities: val.content, //工作内容
        work_performance: val.result, //工作业绩
        department: val.port, //所属部门
      };
      this.SaveInfo("resumeSaveWorkExperience", params);
    },
    saveProjectExperience(val) {
      let params = {
        project_id: val.project_id, //项目经历id，编辑时必填
        name: val.name, //项目名称
        role: val.role[val.role.length - 1], //项目角色
        link: val.link, //项目链接
        start_time: val.time[0], //项目-开始日期
        end_time: val.time[1], //项目-结束日期
        project_introduction: val.content, //项目描述
        project_performance: val.result, //项目业绩
      };
      this.SaveInfo("resumeSaveProjectExperience", params);
    },
    saveEducation(val) {
      let params = {
        education_id: val.education_id, //教育经历id，编辑时必填
        school_name: val.school, //学校名称
        program_type: val.system, //学制类型
        degree: val.educational, //学历
        major: val.professional, //专业
        start_time: val.time[0], //项目-开始日期
        end_time: val.time[1], //项目-结束日期
        campus_experience: val.at_school, //在校经历
      };
      this.SaveInfo("resumeSaveEducation", params);
    },
    saveCertificate(val) {
      let params = {
        certificate: val, //资格证书
      };
      this.SaveInfo("resumeSaveCertificate", params);
    },
    saveJobStatus() {
      let params = {
        job_status: 1, //求职状态: 1=离职-随身到岗,2=在职-暂不考虑,3=在职-考虑机会,4=在职-月内到岗
      };
      //   this.SaveInfo("resumeSaveJobStatus", params);
    },
    SaveInfo(apiUrl, params) {
      this.$httpStudent.axiosPost(this.$api[apiUrl], params, (res) => {
        if (res.code === 200) {
          this.getInfoDetial();
          this.$message.success("修改成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    deleteInfo(apiUrl, params) {
      this.$httpStudent.axiosPost(this.$api[apiUrl], params, (res) => {
        if (res.code === 200) {
          this.getInfoDetial();
          this.$message.success("删除成功");
          this.getInfoDetial();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    viewResume() {
      this.drawerVisible = true;
    },
    closeDrawer() {
      this.drawerVisible = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.jianli_box {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 40px 0;
  box-sizing: border-box;
  .resume_box {
    width: 1340px;
    display: flex;
    height: 100%;
    .left {
      width: 102px;
      .menu_item {
        width: 102px;
        height: 36px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        text-align: center;
        line-height: 36px;
        margin-bottom: 10px;
        cursor: pointer;
        a {
          &:hover {
            color: #685ef5;
          }
        }
      }
      .active_menu_item {
        background: #dedbff;
        a {
          color: #685ef5;
        }
      }
    }
    .right_box {
      flex: 1;
      width: 0;
      margin-left: 18px;
      width: 1200px;
      height: 100%;

      .Personal_information {
        min-height: 188px;
        background: #ffffff;
        border-radius: 12px 12px 12px 12px;
        padding: 40px;
        box-sizing: border-box;
        display: flex;
        .image_box {
          width: 108px;
          height: 108px;
          position: relative;
          cursor: pointer;
          margin-right: 28px;
          &:hover {
            .reset_button {
              display: flex;
            }
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .reset_button {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            position: absolute;
            top: 0px;
            left: 0px;
            display: none;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background: rgba(0, 0, 0, 0.3);
            color: #fff;
            font-weight: 500;
            font-size: 12px;
            .el-icon-refresh-right {
              font-size: 18px;
            }
          }
        }
        .personal_info {
          padding: 10px;
          width: 0;
          flex: 1;
          box-sizing: border-box;
          .name {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .person_name {
              font-weight: 500;
              font-size: 26px;
              color: #232323;
            }
            .right_button_box {
              display: flex;
              align-items: center;
              font-weight: 400;
              font-size: 14px;
              color: #685ef5;
              //   width: 100px;
              img {
                width: 16px;
                height: 16px;
                margin-right: 5px;
                cursor: pointer;
              }
            }
          }
          .detial_jianli {
            // display: flex;
            // width: 50%;
            // flex-wrap: wrap
            width: 60%;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            margin-top: 16px;
            .detial_item {
              display: flex;
              align-items: center;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #666666;
              margin-right: 43px;
              margin-bottom: 10px;
              img {
                width: 16px;
                height: 16px;
                margin-right: 10px;
              }
            }
          }
        }
      }
      .edit_box {
        min-height: 188px;
        background: #ffffff;
        border-radius: 12px 12px 12px 12px;
        padding: 10px;
        box-sizing: border-box;
        .content_box {
        }
      }
      .all_info {
        margin-top: 20px;
        min-height: 188px;
        background: #ffffff;
        border-radius: 12px 12px 12px 12px;
        padding: 40px;
        box-sizing: border-box;
        .item_box {
          .header_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left {
              display: flex;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
              }
              .name {
                font-weight: 500;
                font-size: 18px;
                color: #685ef5;
                margin-left: 10px;
              }
              .label {
                margin-left: 5px;
              }
            }
          }
          .info_content {
            padding: 20px 0 0 26px;
            box-sizing: border-box;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            .show_box {
              .job_type {
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                margin-bottom: 20px;
              }
              .hope_work {
                font-weight: 400;
                font-size: 16px;
                color: #222223;
                .line {
                  width: 1px;
                  height: 14px;
                  background: #d2d2d3;
                  display: inline-block;
                  margin: 0 12px;
                }
                .city {
                  color: #99999a;
                }
              }
            }
          }
          .info_edit {
            padding: 10px;
            box-sizing: border-box;
          }
          padding-bottom: 60px;
        }
      }
    }
  }
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

::v-deep(.el-dialog__body) {
  padding-top: 10px;
}
</style>
